

export default {
    setAdminLoginInfo(state,data){

        state.adminLogin=data;
     },
    //设置动态mate信息
    setArtistMarketMeta(state,data){
        let title='';
        let pic="";
        let url="";
        let desc=""
        if(data && data.hasOwnProperty('meta') ){
            title=data.meta.title;
            pic= data.meta.pic;
            url= data.meta.url;
            desc=data.meta.description
        }
        state.mate={
            title:title,
            keywords:title,
            pic:pic,
            url:url,
            desc:desc
        };
     },
     setArtistHomeMeta(state,data){
         let title='';
         let pic="";
         let url="";
         let desc=""
         if(data && data.hasOwnProperty('meta') ){
             title=data.meta.title;
             pic= data.meta.pic;
             url= data.meta.url;
             desc=data.meta.description
         }
         state.mate={
             title:title,
             keywords:title,
             pic:pic,
             url:url,
             desc:desc
         };
     },
     setArtistPrevMeta(state,data){
         let title='';
         let pic="";
         let url="";
         let desc=""
         if(data && data.hasOwnProperty('meta') ){
             title=data.meta.title;
             pic= data.meta.pic;
             url= data.meta.url;
             desc=data.meta.description
         }
         state.mate={
             title:title,
             keywords:title,
             pic:pic,
             url:url,
             desc:desc
         };
     },
     setArtistYjMeta(state,data){
         let title='';
         let pic="";
         let url="";
         let desc=""
         if(data && data.hasOwnProperty('meta') ){
             title=data.meta.title;
             pic= data.meta.pic;
             url= data.meta.url;
             desc=data.meta.description
         }
         state.mate={
             title:title,
             keywords:title,
             pic:pic,
             url:url,
             desc:desc
         };
     },
     setArtistYlistMeta(state,data){
         let title='';
         let pic="";
         let url="";
         let desc=""
         if(data && data.hasOwnProperty('meta') ){
             title=data.meta.title;
             pic= data.meta.pic;
             url= data.meta.url;
             desc=data.meta.description
         }
         state.mate={
             title:title,
             keywords:title,
             pic:pic,
             url:url,
             desc:desc
         };
     },
     setArtistNumbMeta(state,data){
         let title='';
         let pic="";
         let url="";
         let desc=""
         if(data && data.hasOwnProperty('meta') ){
             title=data.meta.title;
             pic= data.meta.pic;
             url= data.meta.url;
             desc=data.meta.description
         }
         state.mate={
             title:title,
             keywords:title,
             pic:pic,
             url:url,
             desc:desc
         };
     },
    setArtistNumbIndex(state,data){
        let title='123456';
         let pic="";
         let url="";
        let desc=""
        if(data && data.hasOwnProperty('meta') ){
            title=data.meta.title;
            pic= data.meta.pic;
            url= data.meta.url;
            desc=data.meta.description
        }
        state.mate={
            title:title,
            keywords:title,
            pic:pic,
            url:url,
            desc:desc
        };
     },
     setArtistNumbResult(state,data){
         let title='估值结果';
         let pic="";
         let url="";
         let desc=""
         if(data && data.hasOwnProperty('meta') ){
             title=data.meta.title;
             pic= data.meta.pic;
             url= data.meta.url;
             desc=data.meta.description
         }
         state.mate={
             title:title,
             keywords:title,
             pic:pic,
             url:url,
             desc:desc
         };
     },
     setArtistNumbAindex(state,data){
        let title='123456';
         let pic="";
         let url="";
         let desc=""
         if(data && data.hasOwnProperty('meta') ){
             title=data.meta.title;
             pic= data.meta.pic;
             url= data.meta.url;
             desc=data.meta.description
         }
         state.mate={
             title:title,
             keywords:title,
             pic:pic,
             url:url,
             desc:desc
         };
     }
}
